import React, { FC } from 'react'
import { CaptionSM } from '@/atoms/Text'
import { FeaturePrompt, FeaturePromptProps } from '@/molecules/FeaturePrompts/FeaturePrompt'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export const WhyDoYouLovePrompt: FC<FeaturePromptProps> = ({ featureName, show, onClick }) => {
  const { t } = useTranslate('watch')

  return (
    <FeaturePrompt promptName="Why Do You Love This Scene" featureName={featureName} onClick={onClick} show={show}>
      <div className="flex w-full max-w-[200px] space-y-1.5 rounded-lg bg-gray-800 px-3 py-2 md:max-w-[350px] md:whitespace-nowrap md:px-6 md:py-4">
        <CaptionSM className="flex items-center justify-center" color="gray-300">
          <Translate t={t} i18nKey="addWhyYouLoveThisScene">
            Add why you love this scene.
            <a className="ml-2 text-oxide-bright">Add</a>
          </Translate>
        </CaptionSM>
      </div>
    </FeaturePrompt>
  )
}
